import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../App.jsx';
import api from '../services/api.js';
import NavBar from '../components/NavBar.jsx';

// Paywall « version complète ».
// - WEB (navigateur, bêta OU prod) : pas d'achat ici → on affiche TOUJOURS le
//   message « va sur l'app mobile » (le déblocage/achat se fait dans l'app).
// - APP NATIVE bêta (BETA_FREE_UNLOCK=1) : bouton qui débloque tout GRATUITEMENT.
// - APP NATIVE prod : l'achat RevenueCat se branchera sur le bouton (puis api.unlockPremium()).

// Le bridge Capacitor injecte window.Capacitor UNIQUEMENT dans l'app native ;
// absent dans un navigateur → distingue web vs mobile sans import ni dépendance (marche dans les 2 arbres).
const isNativeApp =
  typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.() === true;

export default function Unlock() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.getPremiumStatus().then(setStatus).catch(() => {}); }, []);

  const doUnlock = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await api.unlockPremium();
      if (refresh) await refresh().catch(() => {});
      navigate('/');
    } catch (e) {
      alert(e.message || "L'achat n'est pas encore disponible.");
    }
    setBusy(false);
  };

  const premium = status?.premium;
  const beta = status?.beta_free_unlock;

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
      <NavBar />
      <div className="container">
        <button className="back-btn" onClick={() => navigate('/')}>← Retour</button>
        <div style={{ textAlign: 'center', maxWidth: 440, margin: '24px auto' }}>
          <div style={{ fontSize: '3rem', marginBottom: 8 }}>🔓</div>
          <h2 style={{ marginBottom: 8 }}>Débloque tout Curiosaurus</h2>
          <p style={{ color: 'var(--text-dim)', marginBottom: 20 }}>
            Un seul achat, et tu ouvres <strong>tous les thèmes</strong> — d'un coup, pour toujours.
          </p>
          <ul style={{ textAlign: 'left', color: 'var(--text-dim)', lineHeight: 1.9, marginBottom: 24, listStyle: 'none', padding: 0 }}>
            <li>🌍 Les 8 thèmes en plus : espace, géographie, histoire, inventions, mythologie, personnages, sport et saveurs du monde</li>
            <li>📝 2 800 questions au total</li>
            <li>⚔️ Duels sur tous les thèmes</li>
            <li>🌳 Fais pousser ton arbre sur tout</li>
            <li>🔗 Encore plus de connexions à découvrir</li>
          </ul>

          {premium ? (
            <div style={{ color: 'var(--accent)', fontWeight: 700 }}>✅ Tu as déjà tout débloqué !</div>
          ) : !isNativeApp ? (
            /* WEB (navigateur) : pas d'achat ici → on renvoie TOUJOURS vers l'app
               mobile (même en bêta ; le déblocage/achat se fait dans l'app). */
            <div style={{ background: 'var(--card-bg, rgba(255,255,255,0.05))', borderRadius: 16, padding: '20px 18px' }}>
              <div style={{ fontSize: '2.4rem', marginBottom: 8 }}>📱</div>
              <p style={{ fontWeight: 700, marginBottom: 10 }}>
                Le déblocage se fait dans l'application mobile
              </p>
              <p style={{ fontSize: '0.9rem', color: 'var(--text-dim)', lineHeight: 1.6, margin: 0 }}>
                Installe <strong>Curiosaurus</strong> sur l'App&nbsp;Store (Android bientôt&nbsp;!),
                débloque tout depuis l'app, puis reconnecte-toi ici avec le même compte&nbsp;:
                tes thèmes te suivent. 🚀
              </p>
            </div>
          ) : beta ? (
            <button className="btn btn-primary" disabled={busy} onClick={doUnlock}
              style={{ width: '100%', maxWidth: 320 }}>
              {busy ? '⏳ Déblocage…' : '🔓 Débloquer tout (bêta gratuit)'}
            </button>
          ) : (
            <>
              <button className="btn btn-primary" disabled
                style={{ opacity: 0.6, cursor: 'default', width: '100%', maxWidth: 320 }}>
                Achat bientôt disponible
              </button>
              <p style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginTop: 12 }}>
                L'achat intégré arrive très bientôt.
              </p>
            </>
          )}
        </div>
      </div>
    </motion.div>
  );
}
